export default __webpack_public_path__ + "assets/models/810f818723fb117193547667f867063b.glb";